import React, { useState } from 'react';
import { LEGEND_TOOLTIP_HIGH_RISK, LEGEND_TOOLTIP_LOW_RISK, LEGEND_TOOLTIP_MODERATE_RISK, LEGEND_TOOLTIP_VERY_HIGH_RISK, LEGEND_TOOLTIP_VERY_LOW_RISK } from '../../../../constants/app';
import classes from './MapLegend.module.css';

export const MapLegend = () => {
    const [isDropdownHidden, setIsDropdownHidden] = useState(false);

    const onLegendTextClick = () => setIsDropdownHidden(!isDropdownHidden);

    const changeLegendPositioning = (classNameToAdd) => {
        return isDropdownHidden ? '' : classNameToAdd;
    }

    return (
        (
            <div className={`${classes.legendContainer} ${changeLegendPositioning(classes.legendContainerWithGradient)}`}>
                {!isDropdownHidden &&
                    <div className={classes.legendGradient}>
                        <div className={`${classes.gradientLayer} ${classes.firstGradientLayer}`}></div>
                        <div className={`${classes.gradientLayer} ${classes.secondGradientLayer}`}></div>
                        <div className={`${classes.gradientLayer} ${classes.thirdGradientLayer}`}></div>
                        <div className={`${classes.gradientLayer} ${classes.fourthGradientLayer}`}></div>
                        <div className={`${classes.tooltip} ${classes.tooltipVeryHighRisk}`}>
                            <span className={`${classes.tooltipText} ${classes.tooltipTextVeryHighRisk}`}>{LEGEND_TOOLTIP_VERY_HIGH_RISK}<br />8.4 - 10</span>
                        </div>
                        <div className={`${classes.tooltip} ${classes.tooltipHighRisk}`}>
                            <span className={`${classes.tooltipText} ${classes.tooltipTextHighRisk}`}>{LEGEND_TOOLTIP_HIGH_RISK}<br />7.3 - 8.4</span>
                        </div>
                        <div className={`${classes.tooltip} ${classes.tooltipModerateRisk}`}>
                            <span className={`${classes.tooltipText} ${classes.tooltipTextModerateRisk}`}>{LEGEND_TOOLTIP_MODERATE_RISK}<br />5.3 - 7.3</span>
                        </div>
                        <div className={`${classes.tooltip} ${classes.tooltipLowRisk}`}>
                            <span className={`${classes.tooltipText} ${classes.tooltipTextLowRisk}`}>{LEGEND_TOOLTIP_LOW_RISK}<br />3.6 - 5.3</span>
                        </div>
                        <div className={`${classes.tooltip} ${classes.tooltipVeryLowRisk}`}>
                            <span className={`${classes.tooltipText} ${classes.tooltipTextVeryLowRisk}`}>{LEGEND_TOOLTIP_VERY_LOW_RISK}<br />0 - 3.6</span>
                        </div>
                    </div>
                }
                <div className={`${classes.legendText} ${changeLegendPositioning(classes.legendTextWithGradient)}`}
                    onClick={onLegendTextClick}>
                    Legend
                    <i className={isDropdownHidden ? `fa fa-arrow-down ${classes.arrowDownIcon}` : `fa fa-arrow-up ${classes.arrowUpIcon}`} />
                </div>
            </div>
        )
    );
};
